import { mapCircle } from "./mapCircle";
import { mapFill } from "./mapFill";
import { mapLayout } from "./mapLayout";
import { mapLine } from "./mapLine";
import { mapNet } from "./mapNet";
import { mapPad } from "./mapPad";
import { mapRectangle } from "./mapRectangle";
import { mapRouteSegment } from "./mapRouteSegment";
import { mapText } from "./mapText";
import { mapVia } from "./mapVia";
export * from "./support/types";
export { toMm } from "./support/utils";
export const nodeMappers = {
    circle: mapCircle,
    container: () => null,
    element: () => null,
    fill: mapFill,
    footprint: () => null,
    group: () => null,
    layout: mapLayout,
    line: mapLine,
    model: () => null,
    net: mapNet,
    pad: mapPad,
    rectangle: mapRectangle,
    root: () => null,
    routeSegment: mapRouteSegment,
    text: mapText,
    via: mapVia,
    zone: () => null,
    smartVia: () => null,
    polygon: () => null,
};
//# sourceMappingURL=index.js.map